export default __webpack_public_path__ + "static/media/wordpress-theme.f7c3ab1b.png";